/** 错误概览 */
import './index.scss';
import React from 'react';
import { Select, Table, Card,message  } from 'antd';
import * as echarts from 'echarts';
import api from '../../lib/api'
import DateTimePicker from "../../components/DateTimePicker";
const { Option } = Select;
const sortFileMap = {
  'callCount': 1,
  'errorCount': 2,
  'httpErrorCount': 3,
  'httpErrorPercent': 4,
  'jsErrorCount': 5,
  'jsErrorPercent': 6
};
let isChangeSize = false; // 标识位 判断是否切换分页条数

class errorDetail extends React.Component{
  state = {
    dateTimeVal: '1个月',
    option: {
      path: '-1',
      startTime: null,
      endTime: null
    },
    scrollY: 560,
    sortFileId: "", // 需要排序的字段 1-调用次数 2-报错总数 3-http报错数 4-http错误率 5-js报错 6-js错误率
    orderBy: "desc", // desc-倒序 asc增序
    loadingtable: false,
    total: 2,
    current: 1,
    tableData: [],
    columns: [{
      title: 'URL',
      dataIndex: 'url'
    }, {
      title: '调用次数',
      dataIndex: 'callCount',
      width: 110,
      sorter: true,
      showSorterTooltip: false
    }, {
      title: '报错总数',
      dataIndex: 'errorCount',
      width: 110,
      sorter: true,
      showSorterTooltip: false
    }, {
      title: 'Http报错',
      dataIndex: 'httpErrorCount',
      width: 110,
      sorter: true,
      showSorterTooltip: false
    }, {
      title: 'Http报错率',
      dataIndex: 'httpErrorPercent',
      width: 130,
      sorter: true,
      showSorterTooltip: false,
      render: httpErrorPercent => (
        <span>{httpErrorPercent}%</span>
      ),
    }, {
      title: 'JS报错',
      dataIndex: 'jsErrorCount',
      width: 100,
      sorter: true,
      showSorterTooltip: false
    }, {
      title: 'JS报错率',
      dataIndex: 'jsErrorPercent',
      width: 110,
      sorter: true,
      showSorterTooltip: false,
      render: jsErrorPercent => (
        <span>{jsErrorPercent}%</span>
      ),
    }],
    dataX: [],
    httpErrorY: [],
    jsErrorY: [],
    urlList: []
  };
  // url选择
  onChangeUrl = (value) =>{
    const option = Object.assign({}, this.state.option, {path: value});
    this.setState({
      option
    }, () => {
      this.getLineData();
      this.getTabledata({size: this.state.pageSize})
    })
  };
  // 日期选择
  handleDateTimePicker = (dateTimeVal, startTime, endTime) => {
    const option = Object.assign({}, this.state.option, {startTime, endTime});
    this.setState({
      dateTimeVal,
      option
    }, () => {
      this.getLineData();
      this.getTabledata({size: this.state.pageSize})
    })
  };
  // 排序
  handleTableChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "paginate") {
      if (isChangeSize) {
        isChangeSize = false;
        this.getTabledata({page: 1, size: pagination.pageSize})
      } else {
        this.getTabledata({page: pagination.current, size: pagination.pageSize})
      }
    } else if (extra.action === "sort"){
      const orderBy = sorter.order === "ascend" ? "asc" : sorter.order === "descend" ? "desc" : "";
      const sortFileId = sorter.order ? sortFileMap[sorter.field] : "";
      this.setState({
        sortFileId,
        orderBy
      }, () => {
        this.getTabledata({size: pagination.pageSize});
      })
    }
  };
  // 表格数据
  getTabledata({page = 1, size = 30}) {
    const {sortFileId, orderBy, option} = this.state;
    this.setState({loadingtable: true})
    api.getErrorStatisticsList({page, pageSize: size, sortFileId, orderBy, url: option.path == -1 ? "" : option.path, startTime: option.startTime, endTime:option.endTime}).then(res => {
      this.setState({loadingtable: false})
      if (res.status === 200 && res.success) {
        this.setState({
          tableData: res.data || [],
          total: res.total,
          current: page
        })
      } else {
        message.error(res.message);
      }
    })
  };
  // 画折线图
  drawLine() {
    let myChart = echarts.init(document.getElementById("line"));
    // 绘制图表
    myChart.setOption({
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['httperror', 'jserror'],
        bottom: 10
      },
      grid: {
        left: '20',
        right: '20',
        top: '30',
        bottom: '40',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: this.state.dataX,
        axisLabel: {
          interval:0,
          rotate: -45
        }
      },
      yAxis: {
        type: 'value'
      },
      series: [{
        name: 'httperror',
        data: this.state.httpErrorY,
        type: 'line'
      }, {
        name: 'jserror',
        type: 'line',
        data: this.state.jsErrorY
      }]
    });
  };
  // 获取折线图接口
  getLineData() {
    // 获取折线图接口
    api.getErrorCountList({...this.state.option, path: this.state.option.path == "-1" ? "" : this.state.option.path}).then(res => {
      if (res.status === 200 && res.success) {
        let dataX = [];
        let httpErrorY = [];
        let jsErrorY = [];
        res.data.forEach(v => {
          dataX.push(v.errorTime);
          httpErrorY.push(v.httpErrorCount);
          jsErrorY.push(v.jsErrorCount)
        })
        this.setState({
          dataX,
          httpErrorY,
          jsErrorY
        }, () => {
          this.drawLine()
        })
      } else {
        message.error(res.message);
      }
    })
  };
  // 条数点击 页数/条数
  onShowSizeChange = (current, size) => {
    isChangeSize = true;
  };
  UNSAFE_componentWillMount() {
    // 获取全部url接口
    api.getErrorUrlList().then(res => {
      if (res.status === 200 && res.success) {
        this.setState({
          urlList: res.data || []
        })
      }
    });
    this.setState({
      scrollY: document.documentElement.clientHeight - 250
    });
    window.onresize= () => {
      this.setState({
        scrollY: document.documentElement.clientHeight - 250
      })
    }
  };
  render() {
    const {dateTimeVal, option, loadingtable, total,current, columns, tableData, urlList, scrollY} = this.state;
    return (
      <div>
        <div className="search-box">
          <Select
            className="url-selects"
            showSearch
            placeholder="请选择"
            optionFilterProp="children"
            onChange={this.onChangeUrl}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            value={option.path}>
            <Option value="-1">全部url</Option>
            {urlList.map(v => {
              return <Option value={v} key={v}>{v}</Option>
            })}
          </Select>
          <DateTimePicker comClassName='float-r' value={dateTimeVal} handleDateTimePicker={this.handleDateTimePicker} />
        </div>
        <Card className="mTop10">
          <div id="line" style={{width: '100%', height: '400px'}}/>
        </Card>

        <Card className="mTop10">
          <Table
            scroll={{x: 1000, y: scrollY}}
            className="tables"
            rowKey="url"
            bordered={true}
            loading={loadingtable}
            dataSource={tableData}
            columns={columns}
            pagination={{
              defaultPageSize:30,
              showTotal: (total) => `共${total}条数据`,
              total: Number(total),
              current: Number(current),
              pageSizeOptions: ["30", "50","100"],
              showSizeChanger: true,
              showQuickJumper: true,
              onShowSizeChange: this.onShowSizeChange
            }}
            onChange={this.handleTableChange}
          />
        </Card>

      </div>
    );
  }
};
export default errorDetail;
